import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { ventures } from '../data/ventures';
import { Wordmark } from './Wordmark';
export function Ventures() {
  return <section id="ventures" className="border-b border-rule bg-paper-alt" data-id="element-90" data-mp="7ujqalj671c8">
      <div className="mx-auto max-w-page px-6 py-20 lg:px-10 lg:py-28" data-id="element-91" data-mp="7uthudjv5gk1">
        <div className="grid gap-8 lg:grid-cols-12" data-id="element-92" data-mp="2wrzjuu9hl9m">
          <div className="lg:col-span-4" data-id="element-93" data-mp="zlpt59q9zd57">
            <p className="font-sans text-[12px] uppercase tracking-overline text-muted" data-id="element-94" data-mp="zkftig3rxwwg">
              The portfolio
            </p>
            <h2 className="mt-6 font-serif text-[clamp(2rem,4vw,3.25rem)] leading-[1.02] tracking-[-0.02em] text-ink" data-id="element-95" data-mp="vm8naf6xsdzi">
              Things I started
            </h2>
          </div>
          <p className="font-sans text-[15px] leading-[1.7] text-ink-soft lg:col-span-5 lg:col-start-6" data-id="element-96" data-mp="ltt4xgrq9ne3">
            Some are still running, most have run their course - which is the honest shape of a builder’s career. Each one taught me something I now use on the advisory side of the desk.
          </p>
        </div>

        <ol className="mt-16 border-t border-rule" data-id="element-97" data-mp="c579j6cgsu5u">
          {ventures.map((venture, index) => <li key={venture.id} className="group border-b border-rule" data-id="element-98" data-mp="h41t4ai9amr0" data-mpi={index}>
              <article className="grid grid-cols-1 items-start gap-y-4 py-8 transition-colors duration-200 ease-out group-hover:bg-paper lg:grid-cols-12 lg:gap-x-8 lg:px-4" data-id="element-99" data-mp="3aatbtubuh8h">
                <div className="flex items-baseline gap-4 lg:col-span-4" data-id="element-100" data-mp="3pgzc324njbk5">
                  <span aria-hidden="true" className="font-sans text-[12px] tabular-nums text-muted" data-id="element-101" data-mp="3ugu5bcbwgd8d">
                    {String(ventures.length - index).padStart(2, '0')}
                  </span>
                  <div data-id="element-102" data-mp="3kinzijmz2my8">
                    <h3 className="text-ink" data-id="element-103" data-mp="3kjz60r7sy8t1">
                      {venture.href ? <a href={venture.href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-4 focus-visible:ring-offset-paper-alt" data-id="element-104" data-mp="1epppivepp52j">
                          <Wordmark name={venture.name} mark={venture.mark} data-id="element-105" data-mp="2ipxhuz9j7yu4" />
                          <ArrowUpRightIcon aria-hidden="true" className="h-[14px] w-[14px]" data-id="element-106" data-mp="2dqb50qxm8klu" />
                          <span className="sr-only" data-id="element-107" data-mp="3aeheps9ea36z">(opens in a new tab)</span>
                        </a> : <Wordmark name={venture.name} mark={venture.mark} data-id="element-108" data-mp="36frtjdi47hcs" />}
                    </h3>
                    <p className="mt-2 font-sans text-[12px] uppercase tracking-[0.14em] text-muted" data-id="element-109" data-mp="2wnuic6r3wpe2">
                      {venture.category} · {venture.place}
                    </p>
                  </div>
                </div>

                <div className="lg:col-span-5" data-id="element-110" data-mp="3pbhvx1tymfr7">
                  <p className="font-sans text-[16px] leading-[1.6] text-ink" data-id="element-111" data-mp="i0d2oei0xc0">{venture.thesis}</p>
                  {venture.brands ? <ul className="mt-4 flex flex-wrap gap-x-2 gap-y-2" data-id="element-112" data-mp="5gbqf9405pyz">
                      {venture.brands.map(brand => <li key={brand} className="border border-rule bg-paper px-2 py-[3px] font-sans text-[12px] text-ink-soft" data-id="element-113" data-mp="aewnx0rvdvjq">
                          {brand}
                        </li>)}
                    </ul> : null}
                </div>

                <div className="lg:col-span-3 lg:text-right" data-id="element-114" data-mp="t6fsvd5gfjoe">
                  <p className="font-sans text-[14px] font-medium text-ink" data-id="element-115" data-mp="y5sn4iynnt10">{venture.role}</p>
                  <p className="mt-1 font-sans text-[13px] tabular-nums text-muted" data-id="element-116" data-mp="y7lnjgiodh0k">
                    {venture.years}
                  </p>
                  <p className="mt-3" data-id="element-117" data-mp="177ifps49wy0d">
                    <span className={`inline-block border px-2 py-[3px] font-sans text-[11px] uppercase tracking-[0.12em] ${venture.status === 'Operating' ? 'border-accent/40 text-accent' : 'border-rule text-muted'}`} data-id="element-118" data-mp="174e3c7gnmvym">
                      {venture.status}
                    </span>
                  </p>
                </div>
              </article>
            </li>)}
        </ol>
      </div>
    </section>;
}